import { render, staticRenderFns } from "./Colored.vue?vue&type=template&id=78a00c48&scoped=true"
import script from "./Colored.vue?vue&type=script&lang=js"
export * from "./Colored.vue?vue&type=script&lang=js"
import style0 from "./Colored.vue?vue&type=style&index=0&id=78a00c48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a00c48",
  null
  
)

export default component.exports